import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { useFormik } from 'formik';
import './WorkforceSearchFilterStyle.css';
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import CustomAddButton from '../../../../Components/custom_components/CustomAddButton/CustomAddButton';
import CustomBreadcrumbs from '../../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs';
import { useNavigate } from 'react-router-dom';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import { get_designation_with_pagination } from '../../../../config/SettingsApis/designationApis';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import { get_roles_with_pagination } from '../../../../config/SettingsApis/rolesApis';
import { statusOptions } from '../../../../utils/constants';
import { emptyWorkforceFilters, resetWorkforceFilters, setWorkforceFilter } from '../../../../features/slices/workforceFilterSlice';
import { useDispatch, useSelector } from 'react-redux';
import { get_classifications_without_pagination } from '../../../../config/SettingsApis/classificationApis';

function WorkforceSearchFilter({ isAddPermission, tableTitle, on_change_value, on_page_count_update }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Get persisted filters from Redux store
    const persistedFilters = useSelector(state => state.workforceFilters.workforceFilters);

    const [rolesList, setRolesList] = useState([]);
    const [designationList, setDesignationList] = useState([]);
    const [classificationList, setClassificationList] = useState([]);

    // FETCH Roles
    const fetchRoles = async () => {
        try {
            const params = {
                status: 1 //1MEANS ACTIVE 
            }
            const response = await get_roles_with_pagination(params);
            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.Rolename,
                    value: item?.RoleID
                }));

                // Set the transformed data to the state
                setRolesList(transformedData || []);
            } else {
                setRolesList([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setRolesList([]);
        }
    };
    const fetchClassifications = async () => {
        try {
            const params = {
                status: 1 //1MEANS ACTIVE 
            }
            const response = await get_classifications_without_pagination(params);
            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response?.data?.map((item) => ({
                    label: item?.ClassificationName,
                    value: item?.id
                }));

                // Set the transformed data to the state
                setClassificationList(transformedData || []);
            } else {
                setClassificationList([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setClassificationList([]);
        }
    };

    // FETCH Designation 
    const fetchDesignation = async () => {
        try {
            const params = {
                status: 1 //1MEANS ACTIVE 
            }
            const response = await get_designation_with_pagination(params);
            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.Designation_Name,
                    value: item?.DesignationId
                }));

                // Set the transformed data to the state
                setDesignationList(transformedData || []);
            } else {
                setDesignationList([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setDesignationList([]);
        }
    };


    useEffect(() => {
        fetchRoles()
        fetchClassifications()
        fetchDesignation()
    }, [])

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: persistedFilters,
    });

    const handleSearch = () => {
        const values = { ...formik.values };
        dispatch(setWorkforceFilter(values)); // Update Redux
        on_change_value(1);                     // Reset to page 1
    }

    const resetFilter = () => {
        dispatch(setWorkforceFilter({ ...emptyWorkforceFilters })); // Update Redux
        formik.resetForm({ values: emptyWorkforceFilters });
        on_change_value(1);
        on_page_count_update(25);

        // dispatch(resetWorkforceFilters()); // Reset Redux state

    };

    // Navigate to Add DailyLog page
    const handleNavigate = () => {
        navigate("/resources/workforce/add", { replace: true });
    };

    const breadcrumbs = ["Resources", `Workforce`];

    return (
        <div className="employee-search-filter-container">
            <div className="employee-search-filter-sub-container">
                <div className="employee-search-filter-header">
                    <div className="employee-search-filter-left">
                        <div className="workforce-table-title">{tableTitle}</div>
                        <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                    </div>
                    <div className="employee-search-filter-right">
                        {isAddPermission && <CustomAddButton label="Add" onClick={handleNavigate} />}
                    </div>
                </div>
                <div className="search-layout-wrapper">
                    <div className="search-filter-container">
                        <div className="search-inputs-fields">
                            {/* Search fields */}
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    name="name"
                                    placeholder="Enter Name"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.name}
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="RoleID"
                                    placeholder="Select Role"
                                    options={rolesList}
                                    value={rolesList?.find(option => option?.value === formik?.values?.RoleID) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("RoleID", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    isDisabled={false}
                                    isMulti={false} // Set to false for single-select
                                    width="200px"
                                />
                            </Grid>

                             <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="classification_id"
                                    placeholder="Select Classification"
                                    options={classificationList}
                                    value={classificationList?.find(option => option?.value === formik?.values?.classification_id) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("classification_id", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    isDisabled={false}
                                    isMulti={false} // Set to false for single-select
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="designation_id"
                                    placeholder="Select Designation"
                                    options={designationList}
                                    value={designationList?.find(option => option?.value === formik?.values?.designation_id) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("designation_id", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    isDisabled={false}
                                    isMulti={false} // Set to false for single-select
                                    width="200px"
                                />

                            </Grid>
                       
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    name="optima_number"
                                    placeholder="Optima Number"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.optima_number}
                                    width="150px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    name="official_number"
                                    placeholder="Official Number"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.official_number}
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    name="passport_number"
                                    placeholder="Passport Number"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik?.values?.passport_number}
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="status"
                                    placeholder="Select Status"
                                    options={statusOptions}
                                    value={statusOptions?.find(option => option?.value === formik?.values?.status) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("status", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    isDisabled={false}
                                    isMulti={false} // Set to false for single-select
                                    width="200px"
                                />
                            </Grid>

                        </div>
                        {/* Search Button */}
                        <div className="search-buttons-fixed-right">
                            <ActionButton
                                onClick={handleSearch}
                                // onClick={() => {
                                //     on_change_value(1)
                                //     searchFilter({ ...formik.values }); // Always trigger search, even if no values changed
                                // }}
                                btnDisable={false}
                                label="Search"
                                btnType="primary"
                            />
                            <ActionButton label="Reset" btnType="outlined" onClick={resetFilter} />
                        </div>

                    </div>
                </div>

            </div>
        </div >
    );
}

export default WorkforceSearchFilter;
